import request from './request'

export function getVehicles () {
  return request({
    url: '/users/vehicles',
    method: 'get'
  })
}
